import { useQuery } from "@tanstack/react-query";
import materialReqService from "../api/materialReq";

export const useGetMaterialReqDetails = ({ projectId, requestId }: { projectId: string | undefined, requestId: string | null }) => {

    const { data, isFetching, isPending, isError, error, isSuccess, refetch } = useQuery({
        queryKey: ["material-requests-listing", projectId, requestId],
        queryFn: () => materialReqService.getMaterialReqById({ projectId, requestId }),
        enabled: !!projectId && !!requestId,
    });

    return {
        data: isSuccess ? data.data : null,
        isFetching,
        isPending,
        isError,
        error,
        refetch
    }

};